export const aufzugoGetPartner = {
  bannerText: 'MEHR KUNDENANFRAGEN FÜR IHREN BETRIEB!',
  bannerTextSmall:
    'Als Partner von Aufzugo.de erhalten Sie telefonisch geprüfte Anfragen von Aufzugsbesitzern aus Deutschland',
  getPartnerNow: 'JETZT PARTNER WERDEN',
  formTitle: 'Werden Sie aufzugo Partnerbetrieb',
  formIntroduction:
    'Sind Sie ein qualifizierter Aufzugsanbieter aus Deutschland? Dann sind Sie herzlich willkommen, sich als Partner bei uns zu bewerben. Bitte teilen Sie uns dazu Ihre Kontaktdaten mit und wir melden uns bei Ihnen zu einem unverbindlichen Informationsgespräch. Wir Prüfen dann ihre Daten und teilen Ihnen mit, zu welchem Zeitpunkt wir Sie in unsere Datenbank aufnehmen.',
  formCompanyInput: 'Firma',
  formAddressInput: 'Adresse',
  formZipInput: 'PLZ',
  formCityInput: 'Ort',
  formContactPersonInput: 'Kontaktperson',
  formPhoneInput: 'Telefonnummer',
  formEmailInput: 'E-Mail',
  formActionScopeInput: 'Wie gross ist ihr Aktionsradius? (km, PLZ, Bundesländer)',
  formCommentInput: 'Bemerkungen',
  formButtonText: 'PARTNERPROFIL SENDEN',
  becomePartner: 'Werden Sie Partner von Aufzugo.de!',
  becomePartnerText:
    'Auf dem Portal Aufzugo.de können Aufzugsbesitzer Ihre Wünsche aller Art äussern. Als unser Partner erhalten Sie anschliessend hochwertige Kundenanfragen aus Deutschland. Alle Anfragen sind speziell auf Ihr Profil abgestimmt, werden telefonisch geprüft und bieten sehr gute Auftragsquoten.',
  offers: 'Anfragen mit Qualität',
  offersText:
    'Aufzugo vermittelt Ihnen nur hochwertige Anfragen von seriösen Kunden mit tatsächlichem Auftragsinteresse',
  saveTime: 'Zeit sparen',
  saveTimeText:
    'Sie erhalten komplette und individuell geprüfte Anfragen, die Sie sofort angehen können',
  noObligations: 'Keine Verpflichtungen',
  noObligationsText:
    'Bei voller Auslastung oder Abwesenheit pausieren Sie einfach Ihr Profil und zahlen in dieser Zeit auch keine Gebühren',
  transparentCosts: 'Transparente Kosten',
  transparentCostsText:
    'Sie bestimmen selbst Ihr monatliches Budget und entscheiden, wieviel Sie zahlen wollen',
  contacts: 'Kontakte knüpfen',
  contactsText:
    'Aufzugo verbindet Sie mit dem Kunden. Sie haben direkten Kontakt und gewinnen neue Stammkunden',
  orders: 'Hochwertige Aufträge',
  ordersText: 'Sie gewinnen den Auftrag und erhalten wertvolle Weiterempfehlungen',
  createProfile: '1. Profil erstellen',
  createProfileText:
    'In wenigen Schritten erstellen Sie Ihr Aufzugo-Profil und definieren Ihre Bedürfnisse',
  defineBudget: '2. Budget festlegen',
  defineBudgetText:
    'Die Höhe Ihres Budgets bestimmt die Anzahl der möglichen Anfragen, die Sie erhalten können',
  getInquiry: '3. Anfrage erhalten',
  getInquiryText:
    'Aufzugo schickt Ihnen passende Anfragen, die auf Ihren Betrieb zugeschnitten sind',
  winInquiry: '4. Aufträge gewinnen',
  winInquiryText: 'Anfrager kontaktieren, Beratungstermin vereinbaren und der Auftrag gehört Ihnen',
  becomePartnerButtonText: 'Partner werden',
  partnerFormSuccessToast: 'Vielen Dank. Ihr Partnerprofil wurde erfolgreich versendet.',
}
